import { render, staticRenderFns } from "./BoardTemplate.vue?vue&type=template&id=30ecb9f0&scoped=true"
import script from "./BoardTemplate.vue?vue&type=script&lang=js"
export * from "./BoardTemplate.vue?vue&type=script&lang=js"
import style0 from "./BoardTemplate.vue?vue&type=style&index=0&id=30ecb9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ecb9f0",
  null
  
)

export default component.exports